import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AlarmStatusCount } from '@models/alarm';
import { OpsAlarmMonitoringService } from '@service/ops-alarms/ops-alarm-monitoring.service';
import { ResponsiveService } from '@service/responsive.service';
import { AlarmLevel } from 'ops/common/models/alarm-level';
import { AlarmMonitoring } from 'ops/common/models/alarm-monitoring';

@Component({
    selector: 'app-header-latest-alarm',
    templateUrl: './ops-header-latest-alarm.component.html',
    styleUrls: ['./ops-header-latest-alarm.component.scss'],
    standalone: false
})
export class OpsHeaderLatestAlarmComponent {
    @Input() alarmStatusCount: AlarmStatusCount;
    @Input() latestAlarm: AlarmMonitoring;
    @Input() isAlarmWindowClosed: boolean;
    @Output() onAlarmWindowOpen = new EventEmitter();
    @Output() onAlarmWindowClose = new EventEmitter();

    constructor(
        private alarmMonitoringService: OpsAlarmMonitoringService,
        public responsive: ResponsiveService,
    ) {}

    clickShowmoreEventTrigger(value: boolean) {
        this.onAlarmWindowClose.emit();
    }

    public onClickAck(alarmData: AlarmMonitoring) {
        this.alarmMonitoringService.ackAlarm(alarmData);
    }

    onAlarmWindowShow() {
        this.onAlarmWindowOpen.emit();
    }

    public shouldDisableButton(alarm: AlarmMonitoring) {
        return !alarm.UnAck || this.alarmMonitoringService.isAckInProgress(alarm) || this.alarmMonitoringService.isBuzzerActive();
    }

    getNumberAlarms(){
        return this.alarmStatusCount[AlarmLevel.Alarm]
    }

    getNumberCaution(){
        return this.alarmStatusCount[AlarmLevel.Caution]
    }

    getNumberWarning(){
        return this.alarmStatusCount[AlarmLevel.Warning]
    }
}
